<div class="color-accordion radius-8 overflow-auto">
  <ng-content></ng-content>
  <ion-accordion-group
    *ngIf="mode === 'accordion'"
    [value]="ACCORDION_VALUE">
    <ion-accordion
      class="w-full color-accordion fx-align-center"
      [value]="value">
      <ion-item
        lines="none"
        slot="header">
        <span class="body-2 text-400 text-grey-400">
          {{ accordionLabel }}
        </span>
      </ion-item>

      <ion-grid
        slot="content"
        class="mx-3 w-auto radius-8 mb-3 bg-white"
        fixed>
        <ion-row class="fx-col fx-gap-1">
          <ng-content select="[content]"></ng-content>
        </ion-row>
      </ion-grid>
    </ion-accordion>
  </ion-accordion-group>
</div>
